import { render, staticRenderFns } from "./DpcSupervisionForm.vue?vue&type=template&id=9e99c79a&"
import script from "./DpcSupervisionForm.vue?vue&type=script&lang=js&"
export * from "./DpcSupervisionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports